import { RL_ROOM_INNER_SPACING as WT } from './shape.maker';

const ROOMS = [
  {
    title: "Room 100' x 34'",
    width: 1200,
    height: 400,
  },
  {
    title: "Room 90' x 34'",
    width: 1000,
    height: 400,
  },
];

const FURNISHINGS = [
  //FIXME:
  // {
  //   title: 'Pared',
  //   source: '',
  //   width: 28,
  //   height: 18,
  //   top: 0,
  //   left: 0,
  //   lrSpacing: 1,
  //   tbSpacing: 12,
  //   parts: [
  //     { type: 'rect', definition: { width: 30, height: 20 } },
  //     { type: 'rect', definition: { width: 30, height: 5, top: 15 } },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:name',
  //         text: '',
  //         top: 22,
  //         left: 8,
  //       },
  //     },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:value',
  //         text: '',
  //         top: 6,
  //         left: 8,
  //       },
  //     },
  //   ],
  // },
  // {
  //   title: 'Pared Parley',
  //   source: '',
  //   width: 28,
  //   height: 18,
  //   top: 0,
  //   left: 0,
  //   lrSpacing: 1,
  //   tbSpacing: 12,
  //   parts: [
  //     { type: 'rect', definition: { width: 30, height: 20 } },
  //     { type: 'rect', definition: { width: 30, height: 5, top: 15 } },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:name',
  //         text: '',
  //         top: 22,
  //         left: 8,
  //       },
  //     },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:value',
  //         text: '',
  //         top: 6,
  //         left: 8,
  //       },
  //     },
  //   ],
  // },
  // {
  //   title: 'T Stand',
  //   source: '',
  //   width: 28,
  //   height: 18,
  //   top: 0,
  //   left: 0,
  //   lrSpacing: 1,
  //   tbSpacing: 12,
  //   parts: [
  //     { type: 'rect', definition: { width: 18, height: 30 } },
  //     {
  //       type: 'rect',
  //       definition: { width: 34, height: 5, top: -7, left: -8 },
  //     },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:name',
  //         text: '',
  //         top: 32,
  //         left: 2,
  //       },
  //     },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:value',
  //         text: '',
  //         top: 12,
  //         left: 2,
  //       },
  //     },
  //   ],
  // },
  // {
  //   title: 'Hurdle',
  //   source: '',
  //   width: 28,
  //   height: 18,
  //   top: 0,
  //   left: 0,
  //   lrSpacing: 1,
  //   tbSpacing: 12,
  //   parts: [
  //     { type: 'rect', definition: { width: 18, height: 30 } },
  //     {
  //       type: 'rect',
  //       definition: { width: 34, height: 5, top: -7, left: -8 },
  //     },
  //     {
  //       type: 'rect',
  //       definition: { width: 34, height: 5, top: 32, left: -8 },
  //     },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:name',
  //         text: '',
  //         top: 39,
  //         left: 2,
  //       },
  //     },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:value',
  //         text: '',
  //         top: 12,
  //         left: 2,
  //       },
  //     },
  //   ],
  // },
  // {
  //   title: 'Hurdle Doble',
  //   source: '',
  //   width: 28,
  //   height: 18,
  //   top: 0,
  //   left: 0,
  //   lrSpacing: 1,
  //   tbSpacing: 12,
  //   parts: [
  //     { type: 'rect', definition: { width: 4, height: 30, left: -4 } },
  //     { type: 'rect', definition: { width: 4, height: 30, left: 18 } },
  //     {
  //       type: 'rect',
  //       definition: { width: 36, height: 5, top: -7, left: -8 },
  //     },
  //     {
  //       type: 'rect',
  //       definition: { width: 36, height: 5, top: 32, left: -8 },
  //     },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:name',
  //         text: '',
  //         top: 39,
  //         left: 2,
  //       },
  //     },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:value',
  //         text: '',
  //         top: 12,
  //         left: 2,
  //       },
  //     },
  //   ],
  // },
  // {
  //   title: 'Threeway',
  //   source: '',
  //   width: 28,
  //   height: 18,
  //   top: 0,
  //   left: 0,
  //   lrSpacing: 1,
  //   tbSpacing: 12,
  //   parts: [
  //     { type: 'rect', definition: { width: 20, height: 30 } },
  //     { type: 'rect', definition: { width: 20, height: 3, top: -6 } },
  //     { type: 'rect', definition: { width: 20, height: 3, top: 33 } },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:name',
  //         text: '',
  //         top: 37,
  //         left: 2,
  //       },
  //     },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:value',
  //         text: '',
  //         top: 12,
  //         left: 2,
  //       },
  //     },
  //   ],
  // },
  // {
  //   title: 'Mesa',
  //   source: '',
  //   width: 28,
  //   height: 18,
  //   top: 0,
  //   left: 0,
  //   lrSpacing: 1,
  //   tbSpacing: 12,
  //   parts: [
  //     { type: 'rect', definition: { width: 50, height: 30 } },
  //     { type: 'rect', definition: { width: 50, height: 3, top: -3 } },
  //     { type: 'rect', definition: { width: 50, height: 3, top: 30 } },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:name',
  //         text: '',
  //         top: 35,
  //         left: 18,
  //       },
  //     },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:value',
  //         text: '',
  //         top: 12,
  //         left: 18,
  //       },
  //     },
  //   ],
  // },
  // {
  //   title: 'Mesa Concreto + Hurdle',
  //   source: '',
  //   width: 28,
  //   height: 18,
  //   top: 0,
  //   left: 0,
  //   lrSpacing: 1,
  //   tbSpacing: 12,
  //   parts: [
  //     { type: 'rect', definition: { width: 50, height: 30 } },
  //     {
  //       type: 'rect',
  //       definition: { width: 4, height: 6, top: -6, left: 5 },
  //     },
  //     {
  //       type: 'rect',
  //       definition: { width: 4, height: 6, top: -6, left: 40 },
  //     },
  //     {
  //       type: 'rect',
  //       definition: { width: 50, height: 5, top: -11 },
  //     },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:name',
  //         text: '',
  //         top: 32,
  //         left: 18,
  //       },
  //     },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:value',
  //         text: '',
  //         top: 12,
  //         left: 18,
  //       },
  //     },
  //   ],
  // },
  // {
  //   title: 'Mesa Con Riel',
  //   source: '',
  //   width: 28,
  //   height: 18,
  //   top: 0,
  //   left: 0,
  //   lrSpacing: 1,
  //   tbSpacing: 12,
  //   parts: [
  //     { type: 'rect', definition: { width: 50, height: 30 } },
  //     { type: 'rect', definition: { width: 50, height: 3, top: -3 } },
  //     { type: 'rect', definition: { width: 50, height: 3, top: 30 } },
  //     { type: 'rect', definition: { width: 50, height: 5, top: 33 } },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:name',
  //         text: '',
  //         top: 39,
  //         left: 18,
  //       },
  //     },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:value',
  //         text: '',
  //         top: 12,
  //         left: 18,
  //       },
  //     },
  //   ],
  // },
  // {
  //   title: 'Cubo Parley',
  //   source: '',
  //   width: 28,
  //   height: 18,
  //   top: 0,
  //   left: 0,
  //   lrSpacing: 1,
  //   tbSpacing: 12,
  //   parts: [
  //     { type: 'rect', definition: { width: 50, height: 30 } },
  //     { type: 'rect', definition: { width: 50, height: 3, top: -3 } },
  //     { type: 'rect', definition: { width: 50, height: 3, top: 30 } },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:name',
  //         text: '',
  //         top: 35,
  //         left: 18,
  //       },
  //     },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:value',
  //         text: '',
  //         top: 12,
  //         left: 18,
  //       },
  //     },
  //   ],
  // },
  // {
  //   title: 'Plinth',
  //   source: '',
  //   width: 28,
  //   height: 18,
  //   top: 0,
  //   left: 0,
  //   lrSpacing: 1,
  //   tbSpacing: 12,
  //   parts: [
  //     { type: 'rect', definition: { width: 50, height: 30 } },
  //     { type: 'rect', definition: { width: 50, height: 3, top: -3 } },
  //     { type: 'rect', definition: { width: 50, height: 3, top: 30 } },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:name',
  //         text: '',
  //         top: 35,
  //         left: 18,
  //       },
  //     },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:value',
  //         text: '',
  //         top: 12,
  //         left: 18,
  //       },
  //     },
  //   ],
  // },


  //TODO:MHZ
  //ANDINO MHZ
  {
    title: 'and_m1',
    source: '',
    width: 100,
    height: 100,
    flexible: true,
    parts: [
      { type: 'rect', definition: { width: 5, height: 200, left: -24, top:-40} },
      { type: 'rect', definition: { width: 5, height: 200, left: 18, top:-40 } },
      {
        type: 'rect',
        definition: { width: 35, height: 5, top: -35, left: -18 },
      },
      {
        type: 'rect',
        definition: { width: 35, height: 5, top: 150, left: -18 },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 163,
          left: -20,
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 60,
          left: -14,
        },
      },
    ],
  },
  {
    title: 'and_m2',
    source: '',
    width: 100,
    height: 100,
    flexible: true,
    parts: [
      {
        type: 'rect',
        definition: { width: 100, height: 5, top: 50, left: -8 },
      },
      {
        type: 'rect',
        definition: { width: 100, height: 25, top: 20, left: -8 },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 55,
          left:25,
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 30,
          left: 25,
        },
      },
    ],
  },
  {
    title: 'and_m3',
    source: '',
    width: 100,
    height: 100,
    flexible: true,
    parts: [
      {
        type: 'rect',
        definition: { width: 80, height: 5, top: 50, left: -8 },
      },
      {
        type: 'rect',
        definition: { width: 80, height: 25, top: 20, left: -8 },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 55,
          left: 20
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 30,
          left: 20,
        },
      },
    ],
  },
  {
    title: 'and_m4',
    source: '',
    width: 100,
    height: 100,
    flexible: true,
    parts: [
      {
        type: 'rect',
        definition: { width: 70, height: 5, top: 50, left: -8 },
      },
      {
        type: 'rect',
        definition: { width: 70, height: 25, top: 20, left: -8 },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 55,
          left: 15
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 30,
          left: 15,
        },
      },
    ],
  },
  {
    title: 'and_m5',
    source: '',
    width: 28,
    height: 18,
    top: 0,
    left: 0,
    lrSpacing: 1,
    tbSpacing: 12,
    parts: [
      {
        type: 'rect',
        definition: { width: 30, height: 5, top: -15, left: -8 },
      },  
      {
        type: 'rect',
        definition: { width: 5, height: 35, top: -15, left: -8 },
      },
      {
        type: 'rect',
        definition: { width: 5, height: 35, top: -15, left: 18 },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 20,
          left: -4,
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 2,
          left: -4,
        },
      },
    ],
  },
  {
    title: 'and_m7',
    source: '',
    width: 100,
    height: 100,
    flexible: true,
    parts: [
      {
        type: 'rect',
        definition: { width: 25, height: 5, top: 40, left: -8 },
      },  
      {
        type: 'rect',
        definition: { width: 25, height: 70, top: 45, left: -8 },
      },
      {
        type: 'rect',
        definition: { width: 25, height: 5, top: 115, left: -8 },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 80,
          left: -10,
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 120,
          left: -10,
        },
      },
    ],
  },
  {
    title: 'and_m8',
    source: '',
    width: 100,
    height: 100,
    flexible: true,
    parts: [
      {
        type: 'rect',
        definition: { width: 45, height: 10, top: 30, left:47 },
      },  
      {
        type: 'rect',
        definition: { width: 100, height: 70, top: 45, left: -8 },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 80,
          left: 25,
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 120,
          left: 25,
        },
      },
    ],
  },
  {
    title: 'and_m9',
    source: '',
    width: 100,
    height: 100,
    flexible: true,
    parts: [
      {
        type: 'rect',
        definition: { width: 65, height: 25, top: 30, left: -8 },
      },
      {
        type: 'rect',
        definition: { width: 65, height: 5, top: 20, left: -8 },
      },
   
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 55,
          left: 10
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 35,
          left: 10,
        },
      },
    ],
  },
  {
    title: 'and_m10',
    source: '',
    width: 100,
    height: 100,
    flexible: true,
    parts: [
      {
        type: 'rect',
        definition: { width: 110, height: 40, top: 25, left: -8 },
      },
      {
        type: 'rect',
        definition: { width: 90, height: 25, top: 32, left:2 },
      },
   
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 65,
          left: 30
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 40,
          left: 30,
        },
      },
    ],
  },

  {
    title: 'and_m11',
    source: '',
    width: 100,
    height: 100,
    flexible: true,
    parts: [
      {
        type: 'rect',
        definition: { width: 80, height: 30, top: 25, left: -8 },
      },   
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 55,
          left: 20
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 35,
          left: 20,
        },
      },
    ],
  },
  {
    title: 'and_m12',
    source: '',
    width: 100,
    height: 100,
    flexible: true,
    parts: [
      {
        type: 'rect',
        definition: { width: 45, height: 25, top: 30, left: -8 },
      },
      {
        type: 'rect',
        definition: { width: 45, height: 5, top: 20, left: -8 },
      },
   
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 55,
          left: 3
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 35,
          left: 3,
        },
      },
    ],
  },

  {
    title: 'and_m13',
    source: '',
    width: 28,
    height: 18,
    top: 0,
    left: 0,
    lrSpacing: 1,
    tbSpacing: 12,
    parts: [
      {
        type: 'rect',
        definition: { width: 40, height: 5, top: 15, left: -8 },
      },  
      {
        type: 'rect',
        definition: { width: 5, height: 35, top: -15, left: -8 },
      },
      {
        type: 'rect',
        definition: { width: 5, height: 35, top: -15, left: 28 },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 20,
          left: 2,
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 2,
          left: 1,
        },
      },
    ],
  },
  {
    title: 'and_m14',
    source: '',
    width: 100,
    height: 100,
    flexible: true,
    parts: [
      {
        type: 'rect',
        definition: { width: 5, height: 35, top: 30, left: -14 },
      },
      {
        type: 'rect',
        definition: { width: 65, height: 35, top: 30, left: -10 },
      },
      {
        type: 'rect',
        definition: { width: 5, height: 35, top: 30, left: 55 },
      },
   
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 65,
          left: 4
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 45,
          left: 4,
        },
      },
    ],
  },
  {
    title: 'and_m15',
    source: '',
    width: 100,
    height: 100,
    flexible: true,
    parts: [
      {
        type: 'rect',
        definition: { width: 50, height: 5, top: 30, left: -8 },
      },
      {
        type: 'rect',
        definition: { width: 38, height: 45, top: 35, left: -1 },
      },
      {
        type: 'rect',
        definition: { width: 50, height: 5, top:80, left: -8 },
      },
   
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 87,
          left: -3
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 96,
          left: 7,
        },
      },
    ],
  },
  {
    title: 'and_m16',
    source: '',
    width: 100,
    height: 100,
    flexible: true,
    parts: [
      {
        type: 'rect',
        definition: { width: 50, height: 5, top: 10, left: -8 },
      },
      {
        type: 'rect',
        definition: { width: 38, height: 70, top: 15, left: -1 },
      },
      {
        type: 'rect',
        definition: { width: 50, height: 5, top: 85, left: -8 },
      },
   
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 91,
          left: -3
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 40,
          left: 8,
        },
      },
    ],
  },
  {
    title: 'and_m17',
    source: '',
    width: 100,
    height: 100,
    flexible: true,
    parts: [
      {
        type: 'rect',
        definition: { width: 100, height: 100, top: 10, left: 0 },
      },
      {
        type: 'rect',
        definition: { width: 80, height: 80, top: 20, left: 10 },
      },   
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 50,
          left: 35
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 110,
          left: 35,
        },
      },
    ],
  },
  {
    title: 'and_m18',
    source: '',
    width: 100,
    height: 100,
    flexible: true,
    parts: [
      {
        type: 'rect',
        definition: { width: 20, height: 100, top: 10, left: 15 },
      },  
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 12,
          name: 'TEXT:name',
          text: '',
          top: 110,
          left: 4
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 60,
          left: 18,
        },
      },
    ],
  },

  //TODO:MHZ UNICENTRO 1
  {
    title: 'unicentro_m1',
    source: '',
    width: 100,
    height: 100,
    flexible: true,
    parts: [
      {
        type: 'rect',
        definition: { width: 15, height: 200, top: 10, left: -8 },
      },   
      {
        type: 'text',
        definition: {
          direction: 'VERTICAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 80,
          left: -3
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 210,
          left: -5,
        },
      },
    ],
  },
  {
    title: 'unicentro_m2',
    source: '',
    width: 28,
    height: 18,
    top: 0,
    left: 0,
    lrSpacing: 1,
    tbSpacing: 12,
    parts: [
       { type: 'rect', definition: { width: 20, height: 25 } },
      { type: 'rect', definition: { width: 20, height: 4, top: 11 } },
     
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 28,
          left: -10,
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 8,
          name: 'TEXT:value',
          text: '',
          top: 38,
          left: 9,
        },
      },
    ],
  },
  {
    title: 'unicentro_m3',
    source: '',
    width: 28,
    height: 18,
    top: 0,
    left: 0,
    lrSpacing: 1,
    tbSpacing: 12,
    parts: [
       { type: 'rect', definition: { width: 65, height: 5 } },
      { type: 'rect', definition: { width: 3, height: 25, top: 6, left:5 } },
      { type: 'rect', definition: { width: 3, height: 25, top: 6, left:58 } },
      { type: 'rect', definition: { width: 65, height: 5, top: 30 } },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 35,
          left: 18,
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 12,
          left: 18,
        },
      },
    ],
  },
  {
    title: 'unicentro_m4',
    source: '',
    width: 28,
    height: 18,
    top: 0,
    left: 0,
    lrSpacing: 1,
    tbSpacing: 12,
    parts: [
      { type: 'rect', definition: { width: 55, height: 40 } },
      { type: 'rect', definition: { width: 55, height: 10, top: 45 } },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 15,
          left: 7,
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 55,
          left: 18,
        },
      },
    ],
  },
  {
    title: 'unicentro_m5',
    source: '',
    width: 28,
    height: 18,
    top: 0,
    left: 0,
    lrSpacing: 1,
    tbSpacing: 12,
    parts: [
      { type: 'rect', definition: { width: 3, height: 40 } },
      { type: 'rect', definition: { width: 45, height: 33, top: 4, left:3 } },
      { type: 'rect', definition: { width: 3, height: 40, left: 48 } },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 15,
          left: 5,
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 40,
          left: 18,
        },
      },
    ],
  },
  {
    title: 'unicentro_m6',
    source: '',
    width: 28,
    height: 18,
    top: 0,
    left: 0,
    lrSpacing: 1,
    tbSpacing: 12,
    parts: [
       { type: 'rect', definition: { width: 55, height: 10 } },
      { type: 'rect', definition: { width: 3, height: 35, top: 10, left:5 } },
      { type: 'rect', definition: { width: 3, height: 35, top: 10, left:47 } },
      { type: 'rect', definition: { width: 55, height: 5, top: 45 } },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 50,
          left: 4,
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 25,
          left: 18,
        },
      },
    ],
  },
  {
    title: 'unicentro_m7',
    source: '',
    width: 28,
    height: 18,
    top: 0,
    left: 0,
    lrSpacing: 1,
    tbSpacing: 12,
    parts: [
       { type: 'rect', definition: { width: 5, height: 55 } },
      { type: 'rect', definition: { width: 85, height: 55, left:5 } },
      { type: 'rect', definition: { width: 5, height: 55, left:90 } },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 60,
          left: 40,
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 25,
          left: 40,
        },
      },
    ],
  },
  {
    title: 'unicentro_m8',
    source: '',
    width: 28,
    height: 18,
    top: 0,
    left: 0,
    lrSpacing: 1,
    tbSpacing: 12,
    parts: [
       { type: 'rect', definition: { width: 5, height: 55 } },
      { type: 'rect', definition: { width: 30, height: 45, left:5, top:5 } },
      { type: 'rect', definition: { width: 10, height: 55, left:35 } },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 60,
          left: 2,
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 25,
          left: 10,
        },
      },
    ],
  },
  {
    title: 'unicentro_m9',
    source: '',
    width: 28,
    height: 18,
    top: 0,
    left: 0,
    lrSpacing: 1,
    tbSpacing: 12,
    parts: [
       { type: 'rect', definition: { width: 40, height: 5 } },
      { type: 'rect', definition: { width: 30, height: 20, left:5, top:5 } },
      { type: 'rect', definition: { width: 40, height: 10, top:25 } },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 35,
          left: 2,
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 8,
          left: 14,
        },
      },
    ],
  },
  {
    title: 'unicentro_m10',
    source: '',
    width: 28,
    height: 18,
    top: 0,
    left: 0,
    lrSpacing: 1,
    tbSpacing: 12,
    parts: [
      { type: 'rect', definition: { width: 5, height: 30, left:-5} },
      { type: 'rect', definition: { width: 40, height: 25, top:2 } },
      { type: 'rect', definition: { width: 5, height: 30, left:40} },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 35,
          left: 7,
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 12,
          left: 7,
        },
      },
    ],
  },
  {
    title: 'unicentro_m11',
    source: '',
    width: 28,
    height: 18,
    top: 0,
    left: 0,
    lrSpacing: 1,
    tbSpacing: 12,
    parts: [
      { type: 'rect', definition: { width: 55, height: 10 } },
      { type: 'rect', definition: { width: 55, height: 40, top:15 } },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 25,
          left: 7,
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 55,
          left: 18,
        },
      },
    ],
  },
  {
    title: 'unicentro_m12',
    source: '',
    width: 100,
    height: 100,
    flexible: true,
    parts: [
      { type: 'rect', definition: { width: 30, height: 150 } },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 25,
          left: 8,
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 160,
          left: 8,
        },
      },
    ],
  },
  {
    title: 'unicentro_m13',
    source: '',
    width: 100,
    height: 100,
    flexible: true,
    parts: [
      { type: 'rect', definition: { width: 30, height: 100 } },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 105,
          left: -3,
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 30,
          left: 8,
        },
      },
    ],
  },
  {
    title: 'unicentro_m14',
    source: '',
    width: 100,
    height: 100,
    flexible: true,
    parts: [
      { type: 'rect', definition: { width: 30, height: 30 } },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 30,
          left: -4,
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 9,
          left: 9,
        },
      },
    ],
  },
  {
    title: 'CTR-M04',
    source: '',
    width: 28,
    height: 18,
    top: 0,
    left: 0,
    lrSpacing: 1,
    tbSpacing: 12,
    parts: [
      {
        type: 'rect',
        definition: { width: 60, height: 5, top: -15, left: -8 },
      },  
      {
        type: 'rect',
        definition: { width: 8, height: 30, top: -15, left: -8 },
      },
      {
        type: 'rect',
        definition: { width: 8, height: 30, top: -15, left: 50 },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 20,
          left: 3,
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 2,
          left: 3,
        },
      },
    ],
  },
  {
    title: 'CTR-M28',
    source: '',
    width: 100,
    height: 100,
    flexible: true,
    parts: [
      {
        type: 'rect',
        definition: { width: 90, height:90},
      },  
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 91,
          left: 20,
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 101,
          left: 35,
        },
      },
    ],
  },
  {
    title: 'CTR-M27',
    source: '',
    width: 100,
    height: 100,
    flexible: true,
    parts: [
      {
        type: 'rect',
        definition: { width: 100, height:100},
      },  
      {
        type: 'rect',
        definition: { width: 50, height: 5, top: 17, left: 7 },
      },
      {
        type: 'rect',
        definition: { width: 38, height: 60, top: 22, left: 14},
      },
      {
        type: 'rect',
        definition: { width: 50, height: 5, top: 81, left: 7 },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: '',
          top: 40,
          left: 12,
        },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:value',
          text: '',
          top: 4,
          left: 8,
        },
      },
    ],
  },
];




const DOORS = [
  {
    title: 'Narrow Door (28" wide)',
    parts: [
      {
        type: 'rect',
        definition: {
          left: 0,
          width: 28,
          top: 0,
          height: WT,
          fill: 'white',
          strokeWidth: 0,
          originX: 'left',
          originY: 'top',
        },
      },
      {
        type: 'line',
        line: [0, 0, 0, `${WT + 28}`],
        definition: { stroke: 'black', strokeWidth: 1 },
      },
      {
        type: 'path',
        path: `M 0 ${WT + 28} Q 28, ${WT + 28}, 28, ${WT}`,
        definition: { stroke: '#ddd', strokeWidth: 1, fill: 'transparent' },
      },
    ],
  },
  {
    title: 'Normal Door (32" wide)',
    parts: [
      {
        type: 'rect',
        definition: {
          left: 0,
          width: 32,
          top: 0,
          height: WT,
          fill: 'white',
          strokeWidth: 0,
          originX: 'left',
          originY: 'top',
        },
      },
      {
        type: 'line',
        line: [0, 0, 0, `${WT + 32}`],
        definition: { stroke: 'black', strokeWidth: 1 },
      },
      {
        type: 'path',
        path: `M 0 ${WT + 32} Q 32, ${WT + 32}, 32, ${WT}`,
        definition: { stroke: '#ddd', strokeWidth: 1, fill: 'transparent' },
      },
    ],
  },
  {
    title: 'Wide Door (36" wide)',
    parts: [
      {
        type: 'rect',
        definition: {
          left: 0,
          width: 36,
          top: 0,
          height: WT,
          fill: 'white',
          strokeWidth: 0,
          originX: 'left',
          originY: 'top',
        },
      },
      {
        type: 'line',
        line: [0, 0, 0, `${WT + 36}`],
        definition: { stroke: 'black', strokeWidth: 1 },
      },
      {
        type: 'path',
        path: `M 0 ${WT + 36} Q 36, ${WT + 36}, 36, ${WT}`,
        definition: { stroke: '#ddd', strokeWidth: 1, fill: 'transparent' },
      },
    ],
  },
  {
    title: 'Double Doors (64" wide)',
    parts: [
      {
        type: 'rect',
        definition: {
          left: 0,
          width: 64,
          top: 0,
          height: WT,
          fill: 'white',
          strokeWidth: 0,
          originX: 'left',
          originY: 'top',
        },
      },
      {
        type: 'line',
        line: [0, 0, 0, `${WT + 32}`],
        definition: { stroke: 'black', strokeWidth: 1},
      },
      {
        type: 'path',
        path: `M 0 ${WT + 32} Q 32, ${WT + 32}, 32, ${WT}`,
        definition: { stroke: '#ddd', strokeWidth: 1, fill: 'transparent' },
      },
      {
        type: 'line',
        line: [64, 0, 64, `${WT + 32}`],
        definition: { stroke: 'black', strokeWidth: 1 },
      },
      {
        type: 'path',
        path: `M 32 ${WT} Q 32, ${WT + 32}, 64, ${WT + 32}`,
        definition: { stroke: '#ddd', strokeWidth: 1, fill: 'transparent' },
      },
    ],
  },

  {
    title: 'Double Doors (64" wide)',
    parts: [
      {
        type: 'rect',
        definition: {
          left: 0,
          width: 64,
          top: 0,
          height: WT,
          fill: 'white',
          strokeWidth: 0,
          originX: 'left',
          originY: 'top',
        },
      },
      {
        type: 'line',
        line: [0, 0, 0, `${WT + 32}`],
        definition: { stroke: 'black', strokeWidth: 1},
      },
      {
        type: 'path',
        path: `M 0 ${WT + 32} Q 32, ${WT + 32}, 32, ${WT}`,
        definition: { stroke: '#ddd', strokeWidth: 1, fill: 'transparent' },
      },
      {
        type: 'line',
        line: [64, 0, 64, `${WT + 32}`],
        definition: { stroke: 'black', strokeWidth: 1 },
      },
      {
        type: 'path',
        path: `M 32 ${WT} Q 32, ${WT + 32}, 64, ${WT + 32}`,
        definition: { stroke: '#ddd', strokeWidth: 1, fill: 'transparent' },
      },
    ],
  },
];

const WINDOWS = [
  {
    title: '2’ Window (24” wide)',
    parts: [
      {
        type: 'rect',
        definition: {
          left: 0,
          width: 24,
          top: 0,
          height: WT - 1,
          fill: 'white',
          strokeWidth: 1,
          originX: 'left',
          originY: 'top',
        },
      },
    ],
  },
  {
    title: '3’ Window (36” wide)',
    parts: [
      {
        type: 'rect',
        definition: {
          left: 0,
          width: 36,
          top: 0,
          height: WT - 1,
          fill: 'white',
          strokeWidth: 1,
          originX: 'left',
          originY: 'top',
        },
      },
    ],
  },
  {
    title: '4’ Window (48” wide)',
    parts: [
      {
        type: 'rect',
        definition: {
          left: 0,
          width: 48,
          top: 0,
          height: WT - 1,
          fill: 'white',
          strokeWidth: 1,
          originX: 'left',
          originY: 'top',
        },
      },
    ],
  },
  {
    title: '6’ Window (72” wide)',
    parts: [
      {
        type: 'rect',
        definition: {
          left: 0,
          width: 72,
          top: 0,
          height: WT - 1,
          fill: 'white',
          strokeWidth: 1,
          originX: 'left',
          originY: 'top',
        },
      },
    ],
  },
];

const MISCELLANEOUS = [
//FIXME:
  // {
  //   title: 'Zone 1',
  //   width: 100,
  //   height: 100,
  //   flexible: true,
  //   parts: [
  //     {
  //       type: 'rect',
  //       definition: { left: 0, top: 0, width: 100, height: 100 },
  //     },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:Text',
  //         text: 'Zona De Lanzamiento',
  //         top: 45,
  //         left: 5,
  //       },
  //     },
  //   ],
  // },
  // {
  //   title: 'Zone 2',
  //   width: 150,
  //   height: 250,
  //   flexible: true,
  //   parts: [
  //     {
  //       type: 'rect',
  //       definition: { left: 0, top: 0, width: 150, height: 200 },
  //     },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:Text',
  //         text: 'PRINT SHOP',
  //         top: 100,
  //         left: 50,
  //       },
  //     },
  //   ],
  // },
  // {
  //   title: 'Zone 3',
  //   width: 100,
  //   height: 100,
  //   flexible: true,
  //   parts: [
  //     {
  //       type: 'rect',
  //       definition: { left: 0, top: 0, width: 100, height: 100 },
  //     },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:Text',
  //         text: 'RUN LAB',
  //         top: 45,
  //         left: 5,
  //       },
  //     },
  //   ],
  // },
  // {
  //   title: 'Zone 4',
  //   width: 300,
  //   height: 100,
  //   flexible: true,
  //   parts: [
  //     {
  //       type: 'rect',
  //       definition: { left: 0, top: 0, width: 300, height: 100 },
  //     },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'HORIZONTAL',
  //         font_size: 10,
  //         name: 'TEXT:Text',
  //         text: 'CALZADO',
  //         top: 45,
  //         left: 100,
  //       },
  //     },
  //   ],
  // },
  // {
  //   title: 'Punto Pago 1',
  //   width: 50,
  //   height: 100,
  //   flexible: true,
  //   parts: [
  //     {
  //       type: 'rect',
  //       definition: { left: 0, top: 0, width: 50, height: 100 },
  //     },
  //     {
  //       type: 'text',
  //       definition: {
  //         direction: 'VERTICAL',
  //         font_size: 8,
  //         name: 'TEXT:Text',
  //         text: 'PUNTO PAGO',
  //         top: 16,
  //         left: 23,
  //       },
  //     },
  //   ],
  // },
  //ANDINO MHZ
  {
    title: 'Caja en L',
    source: '',
    width: 100,
    height: 100,
    flexible: true,
    parts: [
      {
        type: 'rect',
        definition: { width: 25, height: 90, top: -15, left: -8 },
      },  
      {
        type: 'rect',
        definition: { width: 90, height: 25, top: 50, left: -8 },
      },
      {
        type: 'text',
        definition: {
          direction: 'HORIZONTAL',
          font_size: 10,
          name: 'TEXT:name',
          text: 'Caja',
          top: 78,
          left: 20,
        },
      },
    ],
  },
  {
    title: 'vestier',
    width: 50,
    height: 100,
    flexible: true,
    parts: [
      {
        type: 'rect',
        definition: { left: 0, top: 0, width: 50, height: 100 },
      },
      {
        type: 'text',
        definition: {
          direction: 'VERTICAL',
          font_size: 10,
          name: 'TEXT:Text',
          text: 'VESTIER',
          top: 16,
          left: 23,
        },
      },
    ],
  },
  {
    title: 'Caja recta',
    width: 50,
    height: 100,
    flexible: true,
    parts: [
      {
        type: 'rect',
        definition: { left: 0, top: 0, width: 40, height: 150 },
      },
      {
        type: 'text',
        definition: {
          direction: 'VERTICAL',
          font_size: 10,
          name: 'TEXT:Text',
          text: '',
          top: 16,
          left: 23,
        },
      },
    ],
  },
];

export { ROOMS, DOORS, WINDOWS, FURNISHINGS, MISCELLANEOUS };
